---
fr:
  email:
    body:
      task_assigned: Une nouvelle tâche liée à %{power_plant} (%{company}) vous a été assignée.
      yield_loss: 'Pertes financières:'
    data_export_error:
      body: Votre demande d'exportation de données n'a pas pu être complétée car les données de taux de change sont manquantes pour la période et la devise sélectionnées.
      contact_support: Veuillez contacter le support pour obtenir de l'aide.
      error_details: 'Détails de l''erreur: %{message}'
      greeting: Bonjour %{name},
    footer:
      auto_generated: Cet e-mail a été généré automatiquement.
      here: ici
      kaiasolutions_staff: Personnel
      notifications: Plus d'informations sur le %{portal_href}."
      notifications_plain: Vous recevez cette notification car vous avez accès à %{brand}.
      portal_href: O&M Dashboard du Portail
      regards: Salutations
    heading:
      greeting: Salut
    subjects:
      data_export_error: Échec de l'exportation des données
      immediate_notifications: Portail - notification immédiate du "%{notification_rule_name}"
      periodic_notifications: Portail - notification "%{notification_rule_name}"
      task_assigned: Tâche assignée
